import { Box, Button, Typography } from '@mui/material'
import dayjs from 'dayjs'

import { ReactComponent as RightArrow } from '../../assets/images/arrowRight.svg'
import { ReactComponent as LeftArrow } from '../../assets/images/arrowLeft.svg'
import { ReactNode } from 'react'

const handleFormateWeekDays = (name: any) => {
  return (<span className='t-font-bold t-font-size-body t-color-gray'>{name[0]}</span>) as ReactNode
}

const renderCustomHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
}: {
  date: any
  changeYear: any
  changeMonth: any
  decreaseMonth: any
  increaseMonth: any
  prevMonthButtonDisabled: any
  nextMonthButtonDisabled: any
}) => {
  const currentMonth = dayjs(date).format('MMM YYYY')

  return (
    <Box className={'t-d-flex t-align-items-center t-justify-content-between t-pl-18 t-pr-18'}>
      <Typography variant='boldTextXlarge'>{currentMonth}</Typography>
      <Box>
        <Button
          className='t-datepicker-nav-btn'
          sx={{ minWidth: 'unset' }}
          startIcon={<LeftArrow />}
          onClick={decreaseMonth}
        />
        <Button
          className='t-datepicker-nav-btn'
          sx={{ minWidth: 'unset' }}
          startIcon={<RightArrow />}
          onClick={increaseMonth}
        />
      </Box>
    </Box>
  )
}

export default {
  handleFormateWeekDays,
  renderCustomHeader,
}
